import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  async logout() {
    location.href = '/app/#/auth/logout';
  }
}
